import { Component } from '@angular/core';
import { MenuController,PopoverController } from '@ionic/angular';
import { Router, NavigationStart  } from '@angular/router';
import { ProfileComponent } from './profile/profile.component'
import { UserService } from './service/user.service';
import { ToastService } from './service/toast.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  openSubmenuKey: string | null = null;
  isSuperAdmin=false;
toggleSubmenu(menu: string) {
  this.selectedMenu = menu;
  this.openSubmenuKey = this.openSubmenuKey === menu ? null : menu;
}

  username:any;
  waba_id:any;
  phone_number_id:any;
  businessId:any;
  selectedMenu: string = 'dashboard';
  isLoginPage: boolean = false; // Flag to track login page
  activeMenuItem: string = 'dashboard';
  userId:any;
  credits:any;
  service:any;
  isWhatsApp=false;
  isRedington=false;
  jwhatsapp=false;
  accountType:any;
  showHead: boolean = false;
  isUser=false;
  isSystemTraf=false;
  isSMS=false;
  isRCS=false;
  isJRCS=false;
  email:any;
  isAdministration=false;

  constructor(
    private menuCtrl: MenuController,
    private router: Router,
    public popoverController: PopoverController,
    private userService:UserService,
    private toastService:ToastService
  ) {

    // Disable right click globally
    // document.addEventListener('contextmenu', (event) => {
    //   event.preventDefault();
    // });

    
 
    // on route change to '/login', set the variable showHead to false
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event['url'] == '/' || event['url'] == '/otp') { // login route should be empty else header will hide only refresh.
          this.showHead = false;
        } else {
          // console.log("NU")
          this.showHead = true;
        }
      }
    });
  }

  async profile(ev: any) {  
    const popover = await this.popoverController.create({  
        component: ProfileComponent,  
        event: ev,  
        animated: true,  
        showBackdrop: true,
        cssClass:'my-popover'
    });  
    return await popover.present();  
  } 

  ionViewWillEnter(){
    this.username = localStorage.getItem('username');
    this.userId = localStorage.getItem('id');
    if (!this.userId) {
      this.router.navigate(['/']); // user is not logged in
      return;
    }
    this.waba_id = localStorage.getItem('whatsapp_businessId');
    this.phone_number_id = localStorage.getItem('phone_no_Id');
    this.businessId = localStorage.getItem('businessId');
    this.service = localStorage.getItem('service');
    this.email = localStorage.getItem('email');
    
    //this.getCredits();

   }

  ngOnInit() {
    this.router.events.subscribe(() => {
      this.isLoginPage = this.router.url === '/';
      this.activeMenuItem = this.router.url.replace('/', ''); // Get current route
      this.userId = localStorage.getItem('id');
      this.username = localStorage.getItem('username');
      this.service = localStorage.getItem('service');
      
      this.email = localStorage.getItem('email');
      this.accountType = localStorage.getItem('accountType');
      if (this.accountType == 'Superadmin') {
        this.isUser = true;
        this.isSuperAdmin=true;
        this.isSystemTraf = true;
        this.isAdministration=true;
      } else {
        this.isUser = true;
        this.isSuperAdmin=false;
        this.isSystemTraf=false;
      }
      if (this.service?.includes('Whatsapp')) {
        this.isWhatsApp = true;
        this.isRedington = false;
        if (this.service?.includes('jio_Whatsapp')){
          this.jwhatsapp = true;
          this.isWhatsApp = false;
          this.isRedington = false;
        }else{
          this.jwhatsapp = false;
        }
      } else if (this.service?.includes('Redington')) {
        this.isRedington = true;
        this.isWhatsApp = false;
      }
      if(this.service?.includes('SMS')){
        this.isSMS=true;
      }else{
        this.isSMS=false;
      }
      if(this.service?.includes('RCS')){
        this.isRCS=true;
        this.isJRCS=false;
      }else{
        this.isRCS=false;
      }
      if(this.service?.includes('JRCS')){
        this.isJRCS=true;
        this.isRCS=false;
      }else{
        this.isJRCS=false;
      }
      this.getCredits();
      const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
      const loginTime = Number(localStorage.getItem('loginTime'));
      const now = Date.now();

      if (isLoggedIn) {
        const elapsed = now - loginTime;
        const timeout = 60 * 60 * 1000; // 60 mins
        //const timeout = 30 * 60 * 1000; // 30 mins
        if (elapsed >= timeout) {
          // Auto logout
          localStorage.removeItem('isLoggedIn');
          localStorage.removeItem('loginTime');
          this.toastService.error('Session expired. Logging out.');
          // Navigate to login
          window.location.href = '/';
        } else {
          // Set timeout for remaining time
          setTimeout(() => {
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('loginTime');
            this.toastService.error('Session expired. Logging out.');
            window.location.href = '/';
          }, timeout - elapsed);
        }
      }

    });
    
  }





 logout(){
  localStorage.clear();
  localStorage.removeItem('id');
  localStorage.removeItem('username');
  localStorage.removeItem('password');
  this.router.navigateByUrl('/', { replaceUrl: true }).then(() => {
    window.location.reload(); // Optional, adds extra security
  });
 }


getCredits(){
  this.userService.getUserwiseCredit(this.userId).subscribe(response=>{
    this.credits = response.availableCredits;
  })
}

  admin() {
    if (this.accountType == 'Superadmin') {
      this.router.navigate(['/user/manage-user']);
    }else{
      this.router.navigate(['/']);
    }
  }

}
